import 'swiper/css'
import '../scss/product.scss'
import productMedia from '../components/product-media'
import productVideo from '../components/product-video'
import { toggleDataActive } from '../utils/toggle-dataset'
import { variantToSlide } from '../components/dynamic-media'
import { DynamicSection } from '../components/dynamic-section'

productMedia();

window.addEventListener('load', async () => {
  variantToSlide('.media-gallery-js')

  productVideo()

  toggleDataActive('.size-guide-js', '#size-guide-js', {
    overlay: true,
    closeSelector: '#size-guide-close-js',
  });

  toggleDataActive('.btn-hubspot-js', '#modal-hubspot-js', {
    overlay: true,
    closeSelector: '#hubspot-close-js',
  })

  window.customElements.define('dynamic-section', DynamicSection)
});
